import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import RegistrySelector from 'registry/RegistrySelector';
import {FilterKey, GenericFilter} from 'search/SearchConstants';
import pick from 'util/pick';

import {BaseFilterFormProps, BASE_FILTER_FORM_PROP_NAMES, FilterStyle} from './base/FilterFormConstants';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';

export interface QueryApiRegistryFilterFormProps extends BaseFilterFormProps {
  filter: GenericFilter<FilterKey.QUERY_API_REGISTRY>;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: GenericFilter<FilterKey.QUERY_API_REGISTRY>) => void;
  onRemove?: () => void;
}

export default function QueryApiRegistryFilterForm(props: QueryApiRegistryFilterFormProps): JSX.Element {
  assert(
    props.filterStyle === FilterStyle.SECONDARY,
    'Registry filter only configured to work as secondary filter'
  );
  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const searchInput = (
    <div className={css(styles.registrySelector)}>
      <RegistrySelector
        onChange={(newValue) => {
          props.onChangeFilter({...props.filter, value: newValue.target.value?.id ?? null});
        }}
        registryId={props.filter.value}
      />
    </div>
  );

  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[searchInput]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove!}
    />
  );
}

const styles = StyleSheet.create({
  registrySelector: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    // This is necessary to vertically center the registry selector when there is only one registry (in which
    // case it renders a hardcoded string rather than a dropdown).
    justifyContent: 'center',
  },
});
